// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { RouteBuilderAreaId } from './RouteBuilderAreaId'
import {
  RouteBuilderAreaNavigation,
  RouteBuilderAreaNavigationIcon,
} from './RouteBuilderAreaNavigation'
import { RouteBuilderAreaRoutes } from './RouteBuilderAreaRoutes'

const LazyRouteBuilderComponent = lazy(() => import('./RouteBuilderArea'))

const RouteBuilderComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRouteBuilderComponent />
  </SuspenseLoadingWrapper>
)

export const RouteBuilderArea = {
  id: RouteBuilderAreaId,
  Icon: RouteBuilderAreaNavigationIcon,
  NavigationComponent: RouteBuilderAreaNavigation,
  route: {
    path: RouteBuilderAreaRoutes.route,
    component: RouteBuilderComponent,
  },
}
